$(document).ready(function () {
    $('#loader-modal').removeClass('visible');
});

$(window).on('unload', function () {
    $('#loader-modal').removeClass('visible');
});


$('.close').on('click', function () {
    $(this).closest('.toast').remove();
});

/**
 * Submit form using form ajax
 */
$('.btn-submit').on('click', function () {
    $('#loader-modal').addClass('visible');
    formAjax($('#form'));
});

/**
 * If button is click disable it for a second and re enable after
 */
$(document).on('click', '.click', function () {
    let btn = $(this);
    let content = $(this).html();
    $(this).html(`<i class="fas fa-sync fa-2x fa-spin"></i>`);
    btn.prop('disabled', true);
    setTimeout(function () {
        btn.prop('disabled', false);
        btn.html(content);
    }, 2000);
});

try {
    (() => {
        'use strict'
        document.querySelector('#navbarSideCollapse').addEventListener('click', () => {
            document.querySelector('.offcanvas-collapse').classList.toggle('open')
        })
    })();
} catch (e) {
}

// This is responsible for the hamburger menu height in relation to the header.
// $(document).ready(function () {
//     let navHeight = $('.navbar').innerHeight();
//     $('.navbar-collapse').css('top', navHeight + 'px');
//     $('header').css('margin-bottom', navHeight + 'px');
//     $(window).resize(function () {
//         navHeight = $('.navbar').innerHeight();
//         $('.navbar-collapse').css('top', navHeight + 'px');
//         $('header').css('margin-bottom', navHeight + 'px');
//     });
// });

updateHeroSectionDynamicWordEn();

function updateHeroSectionDynamicWordEn() {
    let heroSectionDynamicWord = $('.hero-section-dynamic-word[data-language="en"]');
    let words = ['Bowlathon', '5K athon', 'Jogathon', 'Bikeathon', 'Danceathon', 'Readathon', 'Swimathon', 'Skiathon', 'Any athon', 'Walkathon'];
    let index = 0;

    setInterval(() => {
        $(heroSectionDynamicWord).removeClass('hero-section-dynamic-word-fade');
        $(heroSectionDynamicWord).text(words[index]);
        setTimeout(() => {
            $(heroSectionDynamicWord).addClass('hero-section-dynamic-word-fade');
        }, 100);
        index++;
        if (index >= words.length) {
            index = 0;
        }
    }, 2000);
}


$('.site-type-select').on('change', function () {
    if ($(this).val() !== '') {
        window.location.href = $(this).val();
    }
});
